import Card from "components/card";
import React, { useEffect, useRef, useState } from "react";
import InputField from "components/fields/InputField";
import CustomButton from "components/button/custom_button";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { currentUser } from "services/users/authSlice";
import ApiList from "services/apiList";
import { ESService } from "services/esService";
import Select from "components/select";
import { MdDelete } from "react-icons/md";
import Modal from "components/modal";
import Badge from "components/badge";

const LessonDetail = () => {
  const navigate = useNavigate();
  var user = useSelector(currentUser);
  const [values, setValues] = useState({ name: "", shortname: "" });
  const location = useLocation();

  const mount = useRef(true);
  const [description, setDescription] = useState("");
  const [content, setContent] = useState("");
  const [lessonType, setLessonType] = useState();
  const [lessonTypes, setLessonTypes] = useState([]);
  const [count, setCount] = useState(1);

  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState([]);

  const [teachers, setTeachers] = useState([]);
  const [selectedTeachers, setSelectedTeachers] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isOnlyShow, setIsOnlyShow] = useState(false);

  const inputs = [
    {
      id: "l1",
      name: "name",
      type: "text",
      placeholder: "e.g. Математикийн I",
      errorMessage: "Хичээлийн нэр 3-с дээш тэмдэгтээс бүрдэнэ!",
      label: "Хичээлийн нэр",
      pattern: "^.{3,}$",
      required: true,
    },
    {
      id: "l2",
      name: "shortname",
      type: "text",
      placeholder: "e.g. Mат 1",
      errorMessage: "Товч нэр нэр 1-с дээш тэмдэгтээс бүрдэнэ!",
      label: "Товч нэр",
      pattern: "^.{1,}$",
      required: true,
    },
  ];

  useEffect(() => {
    const getData = (id) => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.lessonUrl + id + "/").then((json) => {
        if (json["status"]) {
          if (json["data"]["school"] === null) {
            setIsDisabled(true);
          }
          setValues(json["data"]);
          setCount(json["data"]["count"] ?? 1);
          setDescription(json["data"]["description"] ?? "");
          setContent(json["data"]["content"] ?? "");
          if (
            json["data"]["lesson_type"] !== null &&
            json["data"]["lesson_type"] !== undefined
          ) {
            setLessonType(json["data"]["lesson_type"]["id"]);
          }
          var addedCources = [];
          var addedTeachers = [];
          if (
            json["data"]["lesson_detail"]["courses"] !== null &&
            json["data"]["lesson_detail"]["courses"] !== undefined
          ) {
            for (let i in json["data"]["lesson_detail"]["courses"]) {
              addedCources.push(json["data"]["lesson_detail"]["courses"][i]);
            }
          }
          if (
            json["data"]["lesson_detail"]["teachers"] !== null &&
            json["data"]["lesson_detail"]["teachers"] !== undefined
          ) {
            for (let i in json["data"]["lesson_detail"]["teachers"]) {
              addedTeachers.push(json["data"]["lesson_detail"]["teachers"][i]);
            }
          }
          setSelectedCourse(addedCources);
          setSelectedTeachers(addedTeachers);
        }
      });
    };

    const getLessonType = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.lessonTeacherTypeUrl).then((json) => {
        if (json["status"]) {
          setLessonTypes(json["data"]);
        }
      });
    };
    const getCourse = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.courseUrl).then((json) => {
        if (json["status"]) {
          setCourses(json["data"]);
        }
      });
    };

    const getTeachers = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.userUrl, "role=teachers").then((json) => {
        if (json["status"]) {
          setTeachers(json["data"]);
        }
      });
    };

    if (mount.current) {
      mount.current = false;
      getLessonType();
      getCourse();
      getTeachers();
      if (location.state.id) getData(location.state.id);
      if (location.state.type === "show") {
        setIsOnlyShow(true);
      }
    }
  }, [location.state, user]);

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const changeCount = (event) => {
    const value = event.target.value;
    const parsedValue = parseInt(value, 10);
    if (!isNaN(parsedValue)) {
      setCount(parsedValue);
    }
  };

  const handleSubmit = (e) => {
    if (!e.preventDefault()) {
      const token = user.token;
      const es = new ESService(token);

      var sCourse = [];
      for (let i = 0; i < selectedCourse.length; i++) {
        sCourse.push(parseInt(selectedCourse[i].id));
      }

      var sTeachers = [];
      for (let i = 0; i < selectedTeachers.length; i++) {
        sTeachers.push(parseInt(selectedTeachers[i].id));
      }
      var data = {
        name: values["name"],
        shortname: values["shortname"],
        description: description ?? " ",
        content: content ?? " ",
        courses: sCourse,
        teachers: sTeachers,
        count: count,
        lesson_type: parseInt(lessonType),
      };
      if (location.state.type === "edit") {
        es.put(ApiList.lessonUrl + values["id"] + "/", data).then((json) => {
          if (json["status"]) {
            navigate("/admin/lessons");
          }
        });
      } else {
        es.post(ApiList.lessonUrl, data).then((json) => {
          if (json["status"]) {
            navigate("/admin/lessons");
          }
        });
      }
    }
  };

  const addTeachers = (e) => {
    e.preventDefault();
    setSelectedTeachers((selectedTeachers) => {
      var sTeachers = [...selectedTeachers];
      var value = JSON.parse(e.target.value);
      const isAdded = sTeachers.findIndex(
        (item) => item.id.toString() === value.id.toString()
      );
      if (isAdded === -1) {
        sTeachers.push(value);
      }
      return sTeachers;
    });
  };

  const removeTeachers = (index) => {
    setSelectedTeachers((selectedTeachers) => {
      var sTeachers = [...selectedTeachers];
      sTeachers.splice(index, 1);
      return sTeachers;
    });
  };

  const addCourse = (e) => {
    e.preventDefault();
    setSelectedCourse((selected) => {
      var sCourse = [...selected];
      var value = JSON.parse(e.target.value);
      const isAdded = sCourse.findIndex(
        (item) => item.id.toString() === value.id.toString()
      );
      if (isAdded === -1) {
        sCourse.push(value);
      }
      return sCourse;
    });
  };

  const removeCourse = (index) => {
    setSelectedCourse((selected) => {
      var sCourse = [...selected];
      sCourse.splice(index, 1);
      return sCourse;
    });
  };

  const handleDelete = (e) => {
    const token = user.token;
    const es = new ESService(token);
    es.delete(ApiList.lessonUrl + values["id"] + "/", {}).then((json) => {
      if (json["status"]) {
        navigate("/admin/lessons");
      }
    });
  };

  return (
    <Card extra={"mt-4 w-full bg-white p-5"}>
      <header className="relative flex items-center justify-end pt-4 lg:pr-20">
        {isDisabled || isOnlyShow ? (
          <span></span>
        ) : (
          <button
            className={`rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10  ${
              location.state.type === "edit" ? "block" : "pt-30 hidden"
            }`}
            onClick={() => setShowModal(true)}
          >
            <MdDelete className="h-6 w-6 fill-red-600" />
          </button>
        )}
      </header>
      {isDisabled || isOnlyShow ? (
        <div
          className="mb-4 border-l-4 border-orange-500 bg-orange-100 p-4 text-orange-700 lg:mx-20"
          role="alert"
        >
          <p className="font-bold">Анхааруулга :</p>
          <p>
            Үндсэн хичээл тул засах боломжгүй. Багш болон анги нэмэх боломжтой.
          </p>
        </div>
      ) : (
        <span></span>
      )}

      <div className=" justify-start gap-5 lg:flex lg:px-20 lg:pb-20 ">
        <form onSubmit={handleSubmit}>
          {inputs.map((input) => (
            <InputField
              key={"lesson" + input.id}
              className="lg:w-96"
              disabled={isDisabled || isOnlyShow}
              {...input}
              value={values[input.name]}
              onChange={onChange}
            />
          ))}
          <InputField
            key="count"
            className="lg:w-96"
            disabled={isDisabled || isOnlyShow}
            type="number"
            label="7 хоногт орох тоо"
            errorMessage="7 хоногт орох тоо оруулна уу"
            value={count}
            onChange={changeCount}
          />
          <label
            htmlFor={"zorilgo_label"}
            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
          >
            Зорилго зорилт
          </label>
          <textarea
            key={"description"}
            value={description}
            disabled={isDisabled || isOnlyShow}
            className={`w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none
            ${
              isDisabled === true || isOnlyShow === true
                ? "dark:placeholder:!text-[rgba(255,255,255,0.15)] !border-none !bg-gray-100 dark:!bg-white/5"
                : ""
            } `}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
            rows={5}
            cols={5}
          />
          <label
            htmlFor={"aguulga_label"}
            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
          >
            Агуулга
          </label>
          <textarea
            key={"content"}
            value={content}
            disabled={isDisabled || isOnlyShow}
            className={`w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none
            ${
              isDisabled === true || isOnlyShow === true
                ? "dark:placeholder:!text-[rgba(255,255,255,0.15)] !border-none !bg-gray-100 dark:!bg-white/5"
                : ""
            } `}
            onChange={(e) => {
              setContent(e.target.value);
            }}
            rows={5}
            cols={5}
          />

          <Select
            id="lessonType"
            value={lessonType}
            required={true}
            disabled={isDisabled || isOnlyShow}
            label="Хичээлийн төрөл"
            defaultText="Хичээлийн төрөл сонгоно уу."
            onChange={(selected) => {
              setLessonType(selected.target.value);
            }}
            children={lessonTypes.map((row, index) => {
              return (
                <option key={index} value={row.id}>
                  {row.name}
                </option>
              );
            })}
          />

          <label
            htmlFor={"addTeacherLabel"}
            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
          >
            Багш нэмэх
          </label>
          <br />
          {selectedTeachers.map((row, index) => {
            return (
              <Badge
                key={"teachears_badge" + index}
                index={index}
                text={
                  row.lastname[0].toUpperCase() +
                  ". " +
                  row.firstname +
                  " - " +
                  row.username
                }
                isDisabled={isOnlyShow}
                remove={removeTeachers}
              />
            );
          })}
          <Select
            id="teacher"
            required={false}
            disabled={isOnlyShow}
            value=""
            defaultText="Багш сонгоно уу."
            className="mt-2"
            onChange={addTeachers}
            children={teachers.map((row, index) => {
              return (
                <option key={index} value={JSON.stringify(row)}>
                  {row.lastname[0].toUpperCase() +
                    ". " +
                    row.firstname +
                    " - " +
                    row.username}
                </option>
              );
            })}
          />

          <label
            htmlFor={"angi_nemeh_label"}
            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
          >
            Анги нэмэх
          </label>
          <br />
          {selectedCourse.map((row, index) => {
            return (
              <Badge
                key={"students_badge" + index}
                index={index}
                text={row.number + row.group}
                isDisabled={isOnlyShow}
                remove={removeCourse}
              />
            );
          })}

          <Select
            id="course"
            required={false}
            value=""
            defaultText="Анги сонгоно уу."
            disabled={isOnlyShow}
            className="mt-2"
            onChange={addCourse}
            children={courses.map((row, index) => {
              return (
                <option key={index} value={JSON.stringify(row)}>
                  {row.number}
                  {row.group}
                </option>
              );
            })}
          />
          {isOnlyShow ? (
            <></>
          ) : (
            <CustomButton text="Хадгалах" type="submit" className="mr-3" />
          )}
          <CustomButton
            onClick={() => {
              if (isOnlyShow) {
                window.history.back();
              } else {
                navigate("/admin/lessons");
              }
            }}
            text="Буцах"
            isBack={true}
          />
        </form>

        {showModal ? (
          <Modal
            key={"lessonModal"}
            handleSubmit={handleDelete}
            setShowModal={setShowModal}
            child={
              <p className="text-xl text-navy-700 dark:text-white">
                Та "{values["name"]}
                "-ыг устгахдаа итгэлтэй байна уу? Дараахтай холбоотой бүх зүйл
                устаж болзошгүй
              </p>
            }
            title="Устгах"
          />
        ) : null}
      </div>
    </Card>
  );
};

export default LessonDetail;
